import Image from 'next/image';
import Logo from 'public/static/images/onboarding/logo.svg';

const AutolistLogo = (): JSX.Element => {
  return (
    <>
      <div className="autolist-logo">
        <Image alt="autolist-logo" src={Logo} width={36} height={36} />
      </div>
      <style jsx>{`
        .autolist-logo {
          margin-bottom: 16px;
        }
      `}</style>
    </>
  );
};

export default AutolistLogo;
